import { IBand } from "Bands/types";

import { copy } from "shared/assets";
import { Band } from "shared/assets/icons";
import { IFieldType, IFormFields } from "shared/types";

const fieldsCopy = copy.venueBlock.createVenue.fields;

export interface VenueBandsModalFieldsProps {
  userBands: IBand[];
  venueBandIds: string[] | undefined;
  bandCount?: number;
}

export const getFields = ({
  userBands,
  venueBandIds,
  bandCount,
}: VenueBandsModalFieldsProps): IFormFields => {
  const subText =
    venueBandIds && bandCount && venueBandIds.length < bandCount
      ? `and ${bandCount} bands`
      : undefined;

  return [
    {
      type: IFieldType.checkboxGroup,
      name: "bands",
      label: fieldsCopy.bands,
      options: userBands.map(({ id, title }) => ({
        value: id,
        label: title,
        icon: Band,
      })),
      subText,
    },
  ];
};
